<template>
<div class="ctn">
  <div class="hdr-tools">
    <div class="input-item">
      <div class="hdr-tools-name">密钥名:</div>
      <el-input size="mini" class="hdr-tools-input" v-model="name" @click="postFile" />
    </div>

    <div class="input-item">
      <div class="hdr-tools-name">密钥密码:</div>
      <el-input size="mini" class="hdr-tools-input" v-model="password" show-password @click="postFile" placeholder="加密的密钥需要" />
    </div>
    <el-button class="hdr-tools-btn" size="mini" @click="clear">清空</el-button>
    <el-button class="hdr-tools-btn" size="mini" type="primary" @click="postFile">添加</el-button>
  </div>

  <div class="validate-result">{{tips}}</div>

  <div class="input-area">
    <h4>私钥</h4>
    <el-input type="textarea" placeholder="粘贴私钥(必填)" v-model="text" maxlength="4096" show-word-limit :autosize="{minRows: 5, maxRows: 8}" />
  </div>
  <br>
  <div class="input-area">
    <h4>公钥</h4>
    <el-input type="textarea" placeholder="粘贴公钥(可选)" v-model="publicText" maxlength="4096" show-word-limit :autosize="{minRows: 3, maxRows: 5}" />
  </div>
  <br>
  <div class="input-area">
    <h4>SSH Authorized Key</h4>
    <el-input type="textarea" placeholder="粘贴 SSH Authorized Key(可选)" v-model="sshAuthorizedKeyText" maxlength="4096" show-word-limit :autosize="{minRows: 3, maxRows: 5}" />
  </div>

</div>
</template>

<script>
export default {
  name: "newKeyFromText",
  data() {
    return {
      name: undefined,
      password: undefined,
      text: undefined,
      publicText: undefined,
      sshAuthorizedKeyText: undefined,
      tips: undefined,
    }
  },
  watch: {
    name: function() {
      if (this.name === "" || this.name === undefined) {
        this.tips = "密钥名不能为空"
        return
      }

      let self = this
      this.api.hifs.getPath(self.path, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          self.tips = "检查同名密钥是否存在出错"
        } else {
          // 文件已存在
          if (data == true) {
            self.tips = "同名密钥已存在"
            return
          }
          self.tips = ""
        }
      })
    }
  },
  computed: {
    path: function() {
      return `/keys/${this.name}`
    },
  },
  methods: {
    clear: function() {
      this.text = undefined
      this.password = undefined
      this.publicText = undefined
      this.sshAuthorizedKeyText = undefined
      this.name = undefined
      this.$nextTick(() => {
        this.tips = undefined
      })
    },
    postFile: function() {
      if (this.name === "" || this.name === undefined) {
        this.tips = "invalid name"
        return
      }

      if (this.text === "" || this.text === undefined) {
        this.tips = "invalid private key"
        return
      }

      let self = this
      this.api.hifs.getPath(self.path, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          self.tips = "检查同名密钥是否存在出错"
        } else {
          // 文件已存在
          console.log("get path data:", data)
          if (data == true) {
            self.tips = "同名密钥已存在"
            return
          }

          // 没有设置密码，直接上传
          if (!self.password) {
            // 文件不存在, 上传密钥
            self.tips = ""
            let keyPair = new self.model.KeyPair()
            keyPair.PrivateKey = self.text
            keyPair.Passphrase = self.password
            keyPair.PublicKey = self.publicText
            keyPair.SshAuthorizedKey = self.sshAuthorizedKeyText

            let blob = new Blob([JSON.stringify(keyPair)])
            self.api.hifs.postFile(self.path, blob, (error, data, response) => {
              if (error) {
                self.api.errHandler(self, error, response)
              } else {
                // console.log("postFile success data:", data)
                self.$message.success(`添加密钥 ${self.name} 成功`)
                self.$emit("addSuccess")
              }
            })
          } else {
            let opts = {
              'password': self.password // String | 密码
            };
            self.api.sess.getSessionPasswordEncrypted(opts, (error, data, response) => {
              if (error) {
                self.api.errHandler(self, error, response)
              } else {
                // 获取加密后的密码成功
                console.log("encrypted password success:", data)

                // 文件不存在, 上传密钥
                self.tips = ""
                let keyPair = new self.model.KeyPair()
                keyPair.PrivateKey = self.text
                keyPair.Passphrase = data
                keyPair.PublicKey = self.publicText
                keyPair.SshAuthorizedKey = self.sshAuthorizedKeyText

                let blob = new Blob([JSON.stringify(keyPair)])
                self.api.hifs.postFile(self.path, blob, (error, data, response) => {
                  if (error) {
                    self.api.errHandler(self, error, response)
                  } else {
                    // console.log("postFile success data:", data)
                    self.$message.success(`添加密钥 ${self.name} 成功`)
                    self.$emit("addSuccess")
                  }
                })
              }
            })
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.ctn {
  display: flex;
  flex-direction: column;
}
.hdr-tools {
  display: flex;

  justify-content: space-between;
}
.input-item {
  display: flex;
  align-items: baseline;
}
.hdr-tools-name {
  flex-grow: 0;
  padding-right: 0.5em;
  word-break: keep-all;

  user-select: none;
}
.hdr-tools-input {
  width: 130px;
}
.validate-result {
  width: 100%;
  padding-top: 0.6em;
  font-size: 0.8em;

  display: flex;
  justify-content: flex-end;
  color:brown;
}
.input-area {
  text-align: left;
}
</style>
